import { gql } from '@apollo/client';

export const GET_STRIPE_SAVED_CREDIT_CARDS = gql`
  query SavedStripeCreditCards($countryCode: String!) {
    SavedStripeCreditCards(countryCode: $countryCode) {
      token
      brand
      lastDigits
      expiryMonth
      expiryYear
    }
  }
`;

export const GET_ORDER_SUMMARY = gql`
  query OrderSummary($orderId: ID!, $advertiserNation: String!) {
    orderSummary(orderId: $orderId, advertiserNation: $advertiserNation) {
      orderId
      total {
        value
        currency
      }
      surcharges {
        surchargeType
        amount {
          value
        }
      }
      lineItems {
        # if this is undefined, meaning NOT CPQA
        pricing {
          ... on CappedUnitPrice {
            __typename
            type
            maxBillableUnits
            unitPrice {
              ... on Price {
                costPerApplicant {
                  currency
                  value
                }
              }
            }
            cappedPrice {
              ... on Price {
                costPerApplicant {
                  currency
                  value
                }
              }
            }
            metadata {
              unitType
            }
          }
        }
      }
    }
  }
`;

export const GET_SURCHARGE_AMOUNT = gql`
  query GetSurchargeAmount(
    $creditCardBrand: CreditCardBrandInput!
    $paymentCurrency: Currency!
    $totalForPaymentIntent: SafeInt!
  ) {
    getSurchargeAmount(
      input: {
        creditCardBrand: $creditCardBrand
        paymentCurrency: $paymentCurrency
        totalForPaymentIntent: $totalForPaymentIntent
      }
    ) {
      surchargeAmount
      surchargeApplicable
    }
  }
`;

export const PAYMENT_2C2P_INQUIRY = gql`
  query Payment2c2pInquiry(
    $currency: String!
    $reference: String
    $paymentToken: String
  ) {
    payment2c2pInquiry(
      currency: $currency
      reference: $reference
      paymentToken: $paymentToken
    ) {
      ... on Payment2c2pInquiry {
        __typename
        amount
        currency
        reference
        status
      }
      ... on Payment2c2pInquiryError {
        __typename
        message
      }
    }
  }
`;

export const PAYMENT_2C2P_INVOICE_INQUIRY = gql`
  query Payment2c2pInquiryForInvoices(
    $currency: String!
    $reference: String
    $paymentToken: String
  ) {
    payment2c2pInquiryForInvoices(
      currency: $currency
      reference: $reference
      paymentToken: $paymentToken
    ) {
      ... on Payment2c2pInquiry {
        __typename
        amount
        currency
        reference
        status
      }
      ... on Payment2c2pInquiryError {
        __typename
        message
      }
    }
  }
`;

export const RETRIEVE_PAYMENT_INTENT = gql`
  query RetrievePaymentIntent(
    $id: String!
    $country: String!
    $paymentMethodType: StripePaymentMethod
  ) {
    retrievePaymentIntent(
      id: $id
      country: $country
      paymentMethodType: $paymentMethodType
    ) {
      amount
      currency
      id
      reference
      status
      virtualAccount {
        accountNo
        bank
        bankCode
        bankName
        expires
      }
    }
  }
`;

export const FEATURE_TOGGLE = gql`
  query GetPaymentConfig($site: String!, $country: String!) {
    getPaymentConfig(site: $site, country: $country) {
      features
    }
  }
`;

export const PAYMENT_TOGGLE = gql`
  query GetPaymentMethodForMaintenance($site: String!, $country: String!) {
    getPaymentMethodForMaintenance(site: $site, country: $country) {
      maintenance {
        disableMessage {
          en
        }
        showMaintenance
        paymentMethod
      }
      paymentMethods {
        disableMessage {
          en
        }
        disablePayment
        paymentMethod
        paymentMedium {
          disablePayment
          value
        }
      }
    }
  }
`;

export const SEEK_PAYMENT_DETAILS = gql`
  query GetSeekPaymentIntent($id: ID!, $site: Site, $country: Country) {
    getPaymentIntent(id: $id, site: $site, country: $country) {
      id
      amount
      currency
      reference
      status
      site
      country
      customerId
      expiredDate
    }
  }
`;
